import { Injectable } from '@angular/core';
import { refreshInfiniteModeBlocks } from '@syncfusion/ej2-angular-grids';
import { Toast, ToastModel } from '@syncfusion/ej2-notifications';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public toastInstance: Toast;
  public toastObj: Toast;

  constructor() {

  }

  createToast: Function = (element: HTMLElement, model: ToastModel): Toast => {
    // if (!element.classList.contains('e-toast')) {
    this.toastObj = new Toast(model, element);
    // }
    return this.toastObj
  };

  showSuccessToast: Function = (elemnet: HTMLElement, model: ToastModel) => {
    model.position = { X: 'Right', Y: 'Top' };
    model.cssClass = 'e-toast-success';
    this.toastInstance = this.createToast(elemnet, model);
    this.toastInstance.show();
  }

  showErrorToast: Function = (elemnet: HTMLElement, model: ToastModel) => {
    model.position = { X: 'Right', Y: 'Top' };
    model.cssClass = 'e-toast-danger';
    this.toastInstance = this.createToast(elemnet, model);
    this.toastInstance.show();
  }

  showInfoToast: Function = (elemnet: HTMLElement, model: ToastModel) => {
    model.position = { X: 'Right', Y: 'Top' };
    model.cssClass = 'e-toast-info';
    this.toastInstance = this.createToast(elemnet, model);
    this.toastInstance.show();
  }

  hideToast: Function = () => {
    if (this.toastInstance) {
      this.toastInstance.hide();
    }
  }

  hideToastAll: Function = () => {
    if (this.toastInstance) {
      this.toastInstance.hide('All');
    }
  }
}
